<template>
  <router-view v-if="isReady" />
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      shortLink: null,
      isReady: false
    };
  },
  created() {
    this.eventId = this.$router.currentRoute.params.id;
    this.$axios.get("/events/" + this.eventId).then(event => {
      this.$root.event = event.data;
      this.isReady = true;
    });
  }
};
</script>

<style>
</style>